<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <!-- <div formGroupName="Prevoz"> -->
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <div class="row" *ngIf="izlazna">
            <!-- Broj vožnje -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 #autofocus name="txtBrojVoznje"
                            [Label]="'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR'" formControlName="BrojVoznje"
                            [FormatString]="'1.0-0'">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.BrojVoznje?.invalid">
                            <span *ngFor="let validation of errorMessages.BrojVoznje">
                                <span class="error-message" *ngIf="fc.BrojVoznje?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                        <div class="form-error"
                            *ngIf="submitted && baseFormGroup?.invalid && baseFormGroup?.errors?.checkControlBrojVoznje">
                            <span class="error-message" *ngIf="!baseFormGroup?.errors?.checkControlKolicina?.valid">
                                <span [translate]="baseFormGroup.errors.checkControlBrojVoznje.message"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Prevoznik -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist
                            [ModelName]="'komitent'"
                            [GetName]="'get'"
                            [ModelProperty]="'SNaziv,Mesto'"
                            [OrderBy]="'SNaziv'"
                            [AllowAddNew]="true"
                            [AllowEdit]="false"
                            formControlName="PrevoznikID"
                            [Label]="'EOTPREMNICAPREVOZ.PREVOZNIKNAZIV.SINGULAR'"
                            [Position]="'left'"
                            (OnItemSelected)="onPrevoznikSelect($event)"
                            #cmbPrevoznik
                            (GetItems)="PrimaocGetItems($event)">
                        >
                        </yt-dropdown-picklist>
                    </div>
                </div>
            </div>
            <!--Vozilo-->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12 col-12">
                        <yt-dropdown-picklist
                            #ddlVozilo
                            [ModelName]="'komitentvozilo'"
                            [GetName]="'GetByKomitentID'"
                            [GetParameters]='parameterList'
                            [ModelProperty]="'RgBr'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="true"
                            formControlName="PrevoznikVoziloID"
                            [Label]="'EOTPREMNICAPREVOZ.VOZILO.SINGULAR'"
                            [Position]="'right'"
                            [ngClass]="{'is-invalid': submitted && fc.PrevoznikVoziloID.invalid}"
                            (OnItemSelected)="onVoziloSelect($event)"   
                            [ParentProperty]="PrevoznikID"                        
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.PrevoznikVoziloID.invalid">
                            <span *ngFor="let validation of errorMessages.PrevoznikVoziloID">
                                <span class="error-message" *ngIf="fc.PrevoznikVoziloID.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
         <!-- <div class="row" *ngIf="!izlazna || razvoj"> -->
        <div class="row" *ngIf="!izlazna">
            <!-- Broj vožnje -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 #autofocus name="txtBrojVoznje"
                            [Label]="'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR'" formControlName="BrojVoznje">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.BrojVoznje?.invalid">
                            <span *ngFor="let validation of errorMessages.BrojVoznje">
                                <span class="error-message" *ngIf="fc.BrojVoznje?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                        <div class="form-error"
                            *ngIf="submitted && baseFormGroup?.invalid && baseFormGroup?.errors?.checkControlBrojVoznje">
                            <span class="error-message" *ngIf="!baseFormGroup?.errors?.checkControlKolicina?.valid">
                                <span [translate]="baseFormGroup.errors.checkControlBrojVoznje.message"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>            
            <!-- Naziv prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICAPREVOZ.NAZIVPREVOZNIKA.SINGULAR'"
                            formControlName="NazivPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.NazivPrevoznika?.invalid}" [MaxLength]="50">
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.NazivPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.NazivPrevoznika">
                                <span class="error-message" *ngIf="fc.NazivPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Registarski broj -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.REGISTARSKIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="RegistarskiBrojPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.RegistarskiBrojPrevoznika?.invalid}"
                            [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.RegistarskiBrojPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.RegistarskiBrojPrevoznika">
                                <span class="error-message" *ngIf="fc.RegistarskiBrojPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>                      
        </div>
        <div class="row">
            <!-- Ulica prevoznika -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.ULICAPREVOZNIKA.SINGULAR'"
                            formControlName="UlicaPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.UlicaPrevoznika?.invalid}" [MaxLength]="50">
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.UlicaPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.UlicaPrevoznika">
                                <span class="error-message" *ngIf="fc.UlicaPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Broj u ulici prevoznika -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.BROJUULICIPREVOZNIKA.SINGULAR'"
                            formControlName="BrojUUliciPrevoznika" [ngClass]="{'is-invalid': submitted && fc.BrojUUliciPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.BrojUUliciPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.BrojUUliciPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.BrojUUliciPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Poštanski broj prevoznika -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.POSTANSKIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="PostanskiBrojPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.PostanskiBrojPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PostanskiBrojPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.PostanskiBrojPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.PostanskiBrojPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Grad prevoznika -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.GRADPREVOZNIKA.SINGULAR'"
                            formControlName="GradPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.GradPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.GradPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.GradPrevoznika">
                                <span class="error-message" *ngIf="fc.GradPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Dodatno ulica prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.DODATNOULICAPREVOZNIKA.SINGULAR'"
                            formControlName="DodatnoUlicaPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.DodatnoUlicaPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.DodatnoUlicaPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.DodatnoUlicaPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.DodatnoUlicaPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pib prevoznika -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PIBPREVOZNIKA.SINGULAR'"
                            formControlName="PibPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.PibPrevoznika?.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.PibPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.PibPrevoznika">
                                <span class="error-message" *ngIf="fc.PibPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Matični broj prevoznika -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.MATICNIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="MaticniBrojPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.MaticniBrojPrevoznika?.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.MaticniBrojPrevoznika?.invalid">
                            <span *ngFor="let validation of errorMessages.MaticniBrojPrevoznika">
                                <span class="error-message" *ngIf="fc.MaticniBrojPrevoznika?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- Pocetna lokacija prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12" *ngIf="!izlazna">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR'"
                            formControlName="PocetnaLokacijaPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.PocetnaLokacijaPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PocetnaLokacijaPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.PocetnaLokacijaPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.PocetnaLokacijaPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                     <div class="col-md-12" *ngIf="izlazna">
                        <yt-autocomplete 
                            [ModelName]="'mesto'" 
                            [GetName]="'getByNaziv'" 
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'" 
                            [Label]="'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR'" 
                            formControlName="PrevoznikPocetnaLokacijaID"
                            (OnItemSelected)="onMestoSelected($event, 'pocetna')"
                            [ShowHeader]="true"
                      >
                      </yt-autocomplete>
                        <div class="form-error" *ngIf="submitted && fc.PrevoznikPocetnaLokacijaID.invalid">
                        <span *ngFor="let validation of errorMessages.PrevoznikPocetnaLokacijaID">
                          <span class="error-message" *ngIf="fc.PrevoznikPocetnaLokacijaID.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                </div>
            </div>            
            <!-- Pretovarna tačka prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12" *ngIf="!izlazna">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR'"
                            formControlName="PretovarnaTackaPrevoznika"
                            [ngClass]="{'is-invalid': submitted && fc.PretovarnaTackaPrevoznika.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PretovarnaTackaPrevoznika.invalid">
                            <span *ngFor="let validation of errorMessages.PretovarnaTackaPrevoznika">
                                <span class="error-message"
                                    *ngIf="fc.PretovarnaTackaPrevoznika.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        </div>
                         <div class="col-md-12" *ngIf="izlazna">
                         <yt-autocomplete 
                            [ModelName]="'mesto'" 
                            [GetName]="'getByNaziv'" 
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'" 
                            [Label]="'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR'" 
                            formControlName="PrevoznikPretovarnaTackaID"
                            (OnItemSelected)="onMestoSelected($event, 'krajnja')"
                            [ShowHeader]="true"
                      >
                      </yt-autocomplete>
                        <div class="form-error" *ngIf="submitted && fc.PrevoznikPretovarnaTackaID.invalid">
                        <span *ngFor="let validation of errorMessages.PrevoznikPretovarnaTackaID">
                          <span class="error-message" *ngIf="fc.PrevoznikPretovarnaTackaID.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                </div>
            </div>            
        </div>
        <div class="row">
            <!-- Ime vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.IMEVOZACA.SINGULAR'"
                            formControlName="ImeVozaca"
                            [ngClass]="{'is-invalid': submitted && fc.ImeVozaca.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.ImeVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.ImeVozaca">
                                <span class="error-message"
                                    *ngIf="fc.ImeVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>            
            <!-- Prezime vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PREZIMEVOZACA.SINGULAR'"
                            formControlName="PrezimeVozaca"
                            [ngClass]="{'is-invalid': submitted && fc.PrezimeVozaca.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PrezimeVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.PrezimeVozaca">
                                <span class="error-message"
                                    *ngIf="fc.PrezimeVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>            
            <!-- Telefon vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.TELEFONVOZACA.SINGULAR'"
                            formControlName="TelefonVozaca"
                            [ngClass]="{'is-invalid': submitted && fc.TelefonVozaca.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.TelefonVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.TelefonVozaca">
                                <span class="error-message"
                                    *ngIf="fc.TelefonVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>            
 
        </div>
        <div class="row">
            <!-- E-mail vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.EMAILVOZACA.SINGULAR'"
                            formControlName="EmailVozaca"
                            [ngClass]="{'is-invalid': submitted && fc.EmailVozaca.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.EmailVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.EmailVozaca">
                                <span class="error-message"
                                    *ngIf="fc.EmailVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>  
            <!-- Tip Dokumenta vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.TIPDOKUMENTAVOZACA.SINGULAR'"
                            formControlName="TipDokumentaVozaca"
                            [ngClass]="{'is-invalid': submitted && fc.TipDokumentaVozaca.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.TipDokumentaVozaca.invalid">
                            <span *ngFor="let validation of errorMessages.TipDokumentaVozaca">
                                <span class="error-message"
                                    *ngIf="fc.TipDokumentaVozaca.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>   
            <!-- Broj vozacke dozvole -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.VOZACBROJVOZACKEDOZVOLE.SINGULAR'"
                            formControlName="VozacBrojVozackeDozvole"
                            [ngClass]="{'is-invalid': submitted && fc.VozacBrojVozackeDozvole.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.VozacBrojVozackeDozvole.invalid">
                            <span *ngFor="let validation of errorMessages.VozacBrojVozackeDozvole">
                                <span class="error-message"
                                    *ngIf="fc.VozacBrojVozackeDozvole.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>                     
        </div>    
        <!-- </div>              -->
    </form>
</div>